import ENV from "./Environment";
import Requests from "./Requests";

const baseUrl = `${ENV.base_url}/api/v1/ai_intelligence/ingestion-batches`;

const getBatches = async (userData, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  const response = await Requests.getRequest(
    `${baseUrl}?${params}`,
    userData.jwtToken,
    userData
  );
  if (!response || !response.ok) {
    throw new Error("Unable to load ingestion batches. Please try again.");
  }
  const data = await response.json();
  if (!Array.isArray(data.content) || !Number.isInteger(data.total_pages) || data.total_pages < 0) {
    throw new Error("The batches response was invalid. Please try again.");
  }
  return data;
};

const IngestionService = { getBatches };
export default IngestionService;
